const BASIC_AUTH_CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;

export default BASIC_AUTH_CLIENT_SECRET;
